import type { SupportSettingCategory } from '../../../../../api/services/RiderSupportSettings';

const CANONICAL_ORDER: SupportSettingCategory['name'][] = ['Physical Safety', 'Communication', 'Environment'];

const CATEGORY_LABELS: Record<SupportSettingCategory['name'], string> = {
  'Physical Safety': 'Physical safety',
  Communication: 'Communication',
  Environment: 'Environment',
};

export const orderCategories = (categories: SupportSettingCategory[]): SupportSettingCategory[] => {
  const byName = new Map(categories.map((c) => [c.name, c]));

  return CANONICAL_ORDER.flatMap((name) => {
    const match = byName.get(name);

    return match ? [match] : [];
  });
};

export const getCategoryLabel = (name: SupportSettingCategory['name']): string => CATEGORY_LABELS[name];
